<!-- Filtro y Columnas -->
<div
  class="filtro-container align-end"
  style="overflow: auto"
  [class.d-none]="!selectorColumnas && !search && !filtros.length"
>
  <!-- Filtro -->
  <app-filtro
    style="width: 100%"
    [search]="search"
    [filtros]="filtros"
    [(query)]="query"
    (queryChange)="filterChange()"
    [saveName]="name"
  ></app-filtro>
  <!-- Columnas -->
  @if (columnas) {
    <app-column-select
      [columnas]="columnas"
      (columnsDefChange)="columnsChange($event)"
      [saveName]="name"
      [selectorColumnas]="selectorColumnas"
    ></app-column-select>
  }

  <!-- Crear / exportar / importar: el mismo botón redondo de acento en todas
     las tablas (antes eran PNG de 59px con el celeste horneado). -->
  @if (crear?.mostrar) {
    <button
      mat-mini-fab
      color="accent"
      class="boton-tabla"
      [matTooltip]="$safeNavigationMigration(crear?.tooltip)!"
      (click)="crear?.accion()"
    >
      <mat-icon>add</mat-icon>
    </button>
  }

  @if (exportar?.mostrar) {
    <button
      mat-mini-fab
      color="accent"
      class="boton-tabla"
      [matTooltip]="$safeNavigationMigration(exportar?.tooltip)!"
      [disabled]="exportar?.loading"
      (click)="exportar?.accion()"
    >
      @if (exportar?.loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        <mat-icon>ios_share</mat-icon>
      }
    </button>
  }

  @if (importar && importar.mostrar) {
    <button
      mat-mini-fab
      color="accent"
      class="boton-tabla"
      [matTooltip]="importar.tooltip!"
      (click)="importar.accion()"
    >
      <mat-icon>upload_file</mat-icon>
    </button>
  }
</div>

<!-- Paginator -->
@if (paginatorArriba) {
  <div class="paginator-container-top fondo-85">
    <app-paginator
      #topPaginator
      [saveName]="name"
      [length]="totalCount"
      [pageIndex]="+(query.page || 0)"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="!paginatorSimple"
      [hidePageSize]="paginatorSimple"
      [hideGoTo]="paginatorSimple"
      [fixedPageSize]="paginatorSimple ? 5 : undefined"
      [(query)]="query"
      (queryChange)="paginationChange()"
    ></app-paginator>
  </div>
}

<div class="tabla-contenido">
  <!-- Recarga con datos ya presentes: progress bar en el header (sin desplazar) -->
  @if (datosCargados && (loading || recargando)) {
    <mat-progress-bar
      class="tabla-progress"
      mode="indeterminate"
    ></mat-progress-bar>
  }
  @if (dataSource) {
    <mat-table
      class="responsive fondo-85"
      [dataSource]="dataSource"
      [trackBy]="trackBy"
      matSort
      (matSortChange)="sortChange($event)"
    >
      <mat-header-row
        *matHeaderRowDef="columnsDef; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsDef"></mat-row>
      @if (columnas?.[0]?.footer) {
        <mat-footer-row *matFooterRowDef="columnsDef"></mat-footer-row>
      }
      <!-- Columnas -->
      @for (col of columnas; track col) {
        @if (
          $any(col.header.sort || col.row.field || col.header.label);
          as colDef
        ) {
          <ng-container [matColumnDef]="colDef">
            <!-- Header Sortable -->
            @if (col.header.sortable) {
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [style.max-width]="col.header.maxWidth"
              >
                {{ col.header.label }}
              </mat-header-cell>
            }
            <!-- Header Not Sortable -->
            @if (!col.header.sortable) {
              <mat-header-cell
                *matHeaderCellDef
                [style.max-width]="col.header.maxWidth"
              >
                <!-- Selección de toda la página -->
                @if (col.row.checkbox?.header; as headerCheck) {
                  <mat-checkbox
                    [checked]="headerCheck.checked()"
                    [indeterminate]="headerCheck.indeterminate()"
                    [matTooltip]="col.header.label"
                    (change)="headerCheck.change($event.checked)"
                  ></mat-checkbox>
                } @else {
                  {{ col.header.label }}
                }
              </mat-header-cell>
            }
            <!-- Row -->
            <mat-cell
              *matCellDef="let row"
              [style.max-width]="col.header.maxWidth"
            >
              <!-- Mobile Label -->
              @if (col.header.label !== 'Acciones' && !col.row.checkbox) {
                <span class="mobile-label">
                  {{ col.header.label }}
                </span>
              }
              <div>
                <!-- Selección de la fila -->
                @if (col.row.checkbox; as check) {
                  <mat-checkbox
                    [checked]="check.checked(row)"
                    [disabled]="!!check.disabled?.(row)"
                    (change)="check.change(row, $event.checked)"
                  ></mat-checkbox>
                }
                <!-- Field Content -->
                @if (col.row.field; as field) {
                  <span>
                    <!-- Prefix -->
                    @if (field) {
                      <span>{{ col.row.prefix }}</span>
                    }
                    <!-- Si es solo field -->
                    @if (
                      !col.row.parse &&
                      !col.row.icono &&
                      !col.row.html &&
                      !col.row.links &&
                      !col.row.acciones &&
                      !col.row.accionesGrouped
                    ) {
                      @if (row[field]; as value) {
                        <span
                          [class]="col?.row?.claseCss?.(row)"
                          [matTooltip]="
                            $any(
                              $safeNavigationMigration(col?.row?.tooltip?.(row))
                            )
                          "
                        >
                          {{
                            value
                              | dynamicPipe
                                : $safeNavigationMigration(col.row.pipe?.pipe)
                                : $safeNavigationMigration(col.row.pipe?.args)
                          }}
                        </span>
                      }
                      <!-- No Data -->
                      @if (!row[field] && col?.row?.noData) {
                        <span class="no-info">
                          {{ col?.row?.noData }}
                        </span>
                      }
                    }
                    <!-- Suffix -->
                    @if (field) {
                      <span>{{ col.row.suffix }}</span>
                    }
                  </span>
                }
                <!-- Field Parsed -->
                @if (col.row.parse; as parse) {
                  <span>
                    <!-- Prefix -->
                    @if (parse(row) !== undefined) {
                      <span>{{ col.row.prefix }}</span>
                    }
                    <span
                      [class]="col?.row?.claseCss?.(row)"
                      [matTooltip]="
                        $any($safeNavigationMigration(col?.row?.tooltip?.(row)))
                      "
                    >
                      {{
                        parse(row)
                          | dynamicPipe
                            : $safeNavigationMigration(col.row.pipe?.pipe)
                            : $safeNavigationMigration(col.row.pipe?.args)
                      }}
                    </span>
                    <!-- No Data -->
                    @if (parse(row) === undefined && col?.row?.noData) {
                      <span class="no-info">
                        {{ col?.row?.noData }}
                      </span>
                    }
                    <!-- Suffix -->
                    @if (parse(row) !== undefined) {
                      <span>{{ col.row.suffix }}</span>
                    }
                  </span>
                }
                <!-- Field icono -->
                @if (col.row.icono; as fnIcono) {
                  <span>
                    @if (fnIcono(row); as icono) {
                      <span style="margin: 0.5em">
                        @if (icono.tipo !== 'img') {
                          <mat-icon
                            [style.color]="icono.color"
                            [matTooltip]="icono.tooltip!"
                          >
                            {{ icono.icon }}
                          </mat-icon>
                        }
                        @if (icono.tipo === 'img') {
                          <img
                            [matTooltip]="icono.tooltip!"
                            [src]="icono.icon"
                            alt="icono"
                            style="width: 30px"
                          />
                        }
                      </span>
                    }
                  </span>
                }
                <!-- Field icono -->
                @if (col.row.boton; as fnBoton) {
                  <span>
                    @if (fnBoton(row); as boton) {
                      <span style="margin: 0.5em">
                        <button
                          mat-raised-button
                          [color]="boton.color"
                          [matTooltip]="boton.tooltip || ''"
                          [class]="boton.class"
                          (click)="boton.click?.(row)"
                        >
                          {{ boton.text }}
                        </button>
                        <!-- [disabled]="boton?.disabled?.(row)" -->
                      </span>
                    }
                  </span>
                }
                <!-- Field link -->
                @if (col.row.links; as fnLinks) {
                  <span>
                    @if (fnLinks(row); as links) {
                      <span style="margin: 0.5em">
                        @for (l of links; track trackBy($index, l)) {
                          <p
                            [class]="l.class"
                            [routerLink]="l.route"
                            [matTooltip]="$any(l.tooltip)"
                            (click)="l.click?.()"
                          >
                            {{ l.link }}
                          </p>
                        }
                      </span>
                    }
                  </span>
                }
                <!-- Field HTML -->
                @if (col.row.html; as html2) {
                  <div [innerHTML]="html(html2(row))"></div>
                }
                <!-- Field acciones (+ menú de desborde, en el MISMO contenedor:
                   en spans separados el botón del menú caía a una fila propia) -->
                @if (col.row.acciones || col.row.accionesGrouped) {
                  <span
                    class="acciones-container"
                    [class.con-menu]="!!col.row.accionesGrouped"
                  >
                    @for (accion of col.row.acciones || []; track accion) {
                      @if (!accion?.oculta?.(row)) {
                        <!-- Sin color, el mini-fab toma el surface del theme: en modo
                           claro queda un círculo blanco con sombra sobre el fondo
                           blanco de la tabla, sin contraste (en oscuro no se notaba).
                           El resto de las acciones son círculos pintados, así que el
                           default va acá y no en cada llamador. -->
                        <button
                          class="grid-item"
                          mat-mini-fab
                          [color]="accion.color || 'accent'"
                          [matTooltip]="accion.tooltip"
                          [disabled]="
                            $safeNavigationMigration(accion?.disabled?.(row))
                          "
                          (click)="accion.click(row)"
                        >
                          <mat-icon>{{ accion.icon }}</mat-icon>
                        </button>
                      }
                    }
                    @if (col.row.accionesGrouped; as accionesGrouped) {
                      @if (hayAccionesVisibles(accionesGrouped, row)) {
                        <button
                          class="grid-item boton-menu-acciones"
                          mat-icon-button
                          matTooltip="Más acciones"
                          [matMenuTriggerFor]="menu"
                        >
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="menu-acciones">
                          @for (accion of accionesGrouped; track accion) {
                            @if (!accion?.oculta?.(row)) {
                              <button
                                mat-menu-item
                                class="item-accion"
                                [disabled]="
                                  $safeNavigationMigration(
                                    accion?.disabled?.(row)
                                  )
                                "
                                (click)="accion.click(row)"
                              >
                                <span
                                  class="icono-accion-menu fab"
                                  [class]="
                                    'icono-accion-menu fab c-' +
                                    (accion.color || 'default')
                                  "
                                >
                                  <mat-icon>{{ accion.icon }}</mat-icon>
                                </span>
                                <span class="texto-accion">
                                  {{ accion.tooltip }}
                                </span>
                              </button>
                            }
                          }
                        </mat-menu>
                      }
                    }
                  </span>
                }
              </div>
            </mat-cell>
            <!-- Footer -->
            <mat-footer-cell *matFooterCellDef>
              @if (col.footer?.fn; as fn) {
                <div>
                  <!-- Prefix -->
                  <span>{{ col.footer?.prefix }}</span>
                  <!-- Function -->
                  <span>
                    {{
                      fn(col)
                        | dynamicPipe
                          : $safeNavigationMigration(col.footer?.pipe?.pipe)
                          : $safeNavigationMigration(col.footer?.pipe?.args)
                    }}
                  </span>
                  <!-- Suffix -->
                  <span>{{ col.footer?.suffix }}</span>
                </div>
              }
            </mat-footer-cell>
          </ng-container>
        }
      }
    </mat-table>
  }
  <!-- Carga inicial: las filas que van a venir, debajo del encabezado -->
  @if (!datosCargados) {
    <div #esqueleto class="tabla-esqueleto fondo-85" aria-busy="true">
      <div class="esqueleto esqueleto-filas"></div>
    </div>
  }
  @if (datosCargados && !loading && !datos?.length) {
    <div class="sin-datos fondo-85">
      <mat-icon>{{ iconoSinDatos }}</mat-icon>
      <span>{{ mensajeSinDatos }}</span>
      @if (sugerenciaSinDatos; as sugerencia) {
        <span class="sugerencia">{{ sugerencia }}</span>
      }
    </div>
  }
</div>

@if (paginatorAbajo) {
  <div class="paginator-container fondo-85">
    <app-paginator
      #botPaginator
      [saveName]="name"
      [length]="totalCount"
      [pageIndex]="+(query.page || 0)"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="!paginatorSimple"
      [hidePageSize]="paginatorSimple"
      [hideGoTo]="paginatorSimple"
      [fixedPageSize]="paginatorSimple ? 5 : undefined"
      [(query)]="query"
      (queryChange)="paginationChange()"
    ></app-paginator>
  </div>
}
